import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LeadPopup from './components/LeadPopup';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import AttorneysPage from './pages/AttorneysPage';
import ContactPage from './pages/ContactPage';
import ApplicationMain from './pages/ApplicationMain';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CorporateContracts from './pages/services/CorporateContracts';
import BusinessFormation from './pages/services/BusinessFormation';
import BusinessTransaction from './pages/services/BusinessTransaction';
import MergersAcquisitions from './pages/services/MergersAcquisitions';
import NonProfitLaw from './pages/services/NonProfitLaw';
import GovernmentContracting from './pages/services/GovernmentContracting';
import BusinessDisputes from './pages/services/BusinessDisputes';
import AntiCorruption from './pages/services/AntiCorruption';
import Immigration from './pages/services/Immigration';
import Trademark from './pages/services/Trademark';
import Copyright from './pages/services/Copyright';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();

  const handleGetStarted = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const isApplicationPage = location.pathname === '/application/main';

  return (
    <div className="App">
      <ScrollToTop />
      {!isApplicationPage && <Header onGetStarted={handleGetStarted} />}
      <Routes>
        <Route path="/" element={<HomePage onGetStarted={handleGetStarted} />} />
        <Route path="/about" element={<AboutPage onGetStarted={handleGetStarted} />} />
        <Route path="/attorneys" element={<AttorneysPage onGetStarted={handleGetStarted} />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/application/main" element={<ApplicationMain />} />
        <Route path="/services/corporate-contracts" element={<CorporateContracts onGetStarted={handleGetStarted} />} />
        <Route path="/services/business-formation" element={<BusinessFormation onGetStarted={handleGetStarted} />} />
        <Route path="/services/business-transaction" element={<BusinessTransaction onGetStarted={handleGetStarted} />} />
        <Route path="/services/mergers-acquisitions" element={<MergersAcquisitions onGetStarted={handleGetStarted} />} />
        <Route path="/services/non-profit-law" element={<NonProfitLaw onGetStarted={handleGetStarted} />} />
        <Route path="/services/government-contracting" element={<GovernmentContracting onGetStarted={handleGetStarted} />} />
        <Route path="/services/business-disputes" element={<BusinessDisputes onGetStarted={handleGetStarted} />} />
        <Route path="/services/anti-corruption" element={<AntiCorruption onGetStarted={handleGetStarted} />} />
        <Route path="/services/immigration" element={<Immigration onGetStarted={handleGetStarted} />} />
        <Route path="/services/trademark" element={<Trademark onGetStarted={handleGetStarted} />} />
        <Route path="/services/copyright" element={<Copyright onGetStarted={handleGetStarted} />} />
      </Routes>
      {!isApplicationPage && <Footer />}
      <LeadPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
